
export default function AtLeastOne(v) {
    if(v === undefined || v === null || v === -1 || v === "") {
        return [true, "ต้องเลือกอย่างน้อย 1"];
    }
    return [false, ""];
}